import axios, {AxiosResponse} from 'axios';
import {TimeSeriesEntry} from './TimeSeriesEntry';
import {DateRange} from '../stores/TimeIntervalStore';
import {handleError} from './errorHandling';
import {convertCamelCaseToSnakeCase} from '../utility/ApiParamConversion';
import {KPI} from '../kpi';

export interface TimeSeriesRequest {
    channel: string;
    searchterm: string;
    kpi: KPI;
    interval: DateRange;
    targetCurrency?: string;
    testId?: string;
    variantId?: string;
}

export interface ChannelTimeSeriesRequest {
    channel: string;
    kpi: KPI;
    interval: DateRange;
    targetCurrency?: string;
    testId?: string;
    variantId?: string;
}

export interface KpiCountForSearchtermsRequest {
    interval: DateRange;
    channel: string;
    kpi: KPI;
    searchterms: string[];
}

export interface KpiCountForSearchtermsResponse {
    query: string;
    count: number;
}

export function getHourlySearchtermDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`searchterm/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfSearchChannelDiagramFailed'));
}

export function getHourlySearchtermData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`searchterm/${channel}/hourly/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfSearchtermDiagramFailed'));
}

export function getDailySearchtermDataSummary(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`searchterm/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}/summary`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfSearchChannelDiagramFailed'));
}

export function getDailySearchtermData(request: TimeSeriesRequest): Promise<AxiosResponse<TimeSeriesEntry[]>> {
    const {channel, kpi, ...requestQueryParams} = request;
    return axios
        .get(`searchterm/${channel}/daily/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfSearchtermDiagramFailed'));
}

export function getKpiSum(request: ChannelTimeSeriesRequest): Promise<AxiosResponse<number>> {
    const {kpi, ...requestQueryParams} = request;
    return axios
        .get(`tableData/getKpiSumForSearchTerms/${convertCamelCaseToSnakeCase(kpi)}`, {params: requestQueryParams})
        .catch(handleError('error:loadingOfKpiSumPerChannelFailed'));
}

export function getKpiCountForSearchterms(request: KpiCountForSearchtermsRequest): Promise<AxiosResponse<KpiCountForSearchtermsResponse[]>> {
    const {kpi, ...requestQueryParams} = request;
    return axios
        .get(`tableData/getKpiCountForTenSearchterms/${convertCamelCaseToSnakeCase(kpi)}`, {
            params: {...requestQueryParams},
            paramsSerializer: (params) => serializeParam(params),
        })
        .catch(handleError('error:loadingOfKpiCountForTenSearchtermsFailed'));
}

export const serializeParam = (params: any) => {
    const keys = Object.keys(params);
    const options: string[] = [];
    keys.forEach((key) => {
        const isParamTypeObject = typeof params[key] === 'object';
        const isParamTypeArray = Array.isArray(params[key]);
        if (!isParamTypeObject) {
            options.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
        }
        if (isParamTypeObject && isParamTypeArray) {
            params[key].forEach((element: string) => options.push(`${encodeURIComponent(key)}=${encodeURIComponent(element)}`));
        }
    });
    return options.join('&');
};



// WEBPACK FOOTER //
// ./src/apis/SearchtermAPI.ts